module.exports = __webpack_public_path__ + "static/media/14UNEP15.6ed25836.jpg";